module.exports = __webpack_public_path__ + "img/dec1_2.64667f27.jpg";